(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("filterAF", [], factory);
	else if(typeof exports === 'object')
		exports["filterAF"] = factory();
	else
		root["filterAF"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 